<template>
	<div v-if="notifications.length > 0" class="notifications fixed right-05 top-05 z-50 flex flex-col items-end justify-start">
		<Notifications :notifications="notifications" @remove="remove" @action="onAction" />
	</div>
</template>

<script setup lang="ts">
import { Notifications } from '@bluebrick/saas-ui'
import { storeToRefs } from 'pinia'
import { useNotificationsStore } from '@/features/notifications/useNotificationsStore'

const emit = defineEmits<{
	action: [name: string, payload?: unknown]
}>()

const { notifications } = storeToRefs(useNotificationsStore())
const { remove } = useNotificationsStore()

function onAction(name: string, payload?: unknown) {
	emit('action', name, payload)
}
</script>
